import { z } from 'zod';
import { isoTimestampSchema } from './common';

export const EVENT_TYPES = [
  'branch.created',
  'branch.updated',
  'catalog.updated',
  'table.updated',
  'table.session.updated',
  'order.updated',
  'order.submitted',
  'order.item.cancelled',
  'kitchen.ticket.created',
  'kitchen.ticket.updated',
  'bill.updated',
  'payment.settled',
  'cash_shift.updated',
  'stock.changed',
  'purchase_order.updated',
  'goods_receipt.updated',
  'purchase_request.updated',
  'approval.updated',
  'budget.updated',
  'ap.updated',
  'reservation.updated',
] as const;
export type EventType = (typeof EVENT_TYPES)[number];

/** Envelope shared by outbox events, queue messages and realtime fan-out (spec §10). */
export const eventEnvelopeSchema = z.object({
  event_id: z.string(),
  event_type: z.enum(EVENT_TYPES),
  tenant_id: z.string(),
  branch_id: z.string().nullable(),
  entity_id: z.string(),
  entity_version: z.number().int().nonnegative(),
  occurred_at: isoTimestampSchema,
  request_id: z.string(),
  payload: z.record(z.string(), z.unknown()),
});
export type EventEnvelope = z.infer<typeof eventEnvelopeSchema>;
